/**
 * @generated SignedSource<<9db634024870b3322aec9ea004f4229f>>
 * @relayHash 876dd1ed51260d9cbf47835d7194768e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eb3dba15d458b202626bfcea5d65befda4883877fde34e5f6d37d9d15e794364

import type { ConcreteRequest } from 'relay-runtime';
export type useRecentJiraProjectAndIssueQuery$variables = {
  cloudId: string;
  jql: string;
};
export type useRecentJiraProjectAndIssueQuery$data = {
  readonly jira: {
    readonly issueSearch: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly issueType: {
            readonly name: string;
          } | null;
          readonly key: string;
          readonly projectField: {
            readonly project: {
              readonly key: string;
              readonly name: string;
              readonly webUrl: AGG$URL | null;
            } | null;
          } | null;
          readonly summary: string | null;
          readonly webUrl: AGG$URL | null;
        } | null;
      } | null> | null;
    } | null;
    readonly recentItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly issueType?: {
            readonly name: string;
          } | null;
          readonly key?: string;
          readonly projectField?: {
            readonly project: {
              readonly key: string;
              readonly name: string;
              readonly webUrl: AGG$URL | null;
            } | null;
          } | null;
          readonly summary?: string | null;
          readonly webUrl?: AGG$URL | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type useRecentJiraProjectAndIssueQuery = {
  response: useRecentJiraProjectAndIssueQuery$data;
  variables: useRecentJiraProjectAndIssueQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "jql"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v3 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "includeArchivedProjects": false
    }
  },
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "types",
    "value": [
      "ISSUE"
    ]
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "key"
},
v5 = {
  "kind": "ScalarField",
  "name": "summary"
},
v6 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "concreteType": "JiraIssueType",
    "kind": "LinkedField",
    "name": "issueType",
    "plural": false,
    "selections": [
      (v7/*: any*/)
    ]
  },
  {
    "concreteType": "JiraProjectField",
    "kind": "LinkedField",
    "name": "projectField",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v7/*: any*/),
          (v6/*: any*/)
        ]
      }
    ]
  }
],
v9 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "jql",
        "variableName": "jql"
      }
    ],
    "kind": "ObjectValue",
    "name": "issueSearchInput"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "concreteType": "JiraIssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v10/*: any*/)
  ]
},
v12 = {
  "concreteType": "JiraProjectField",
  "kind": "LinkedField",
  "name": "projectField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        (v7/*: any*/),
        (v6/*: any*/),
        (v10/*: any*/)
      ]
    },
    (v10/*: any*/)
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useRecentJiraProjectAndIssueQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraSearchableEntityConnection",
            "kind": "LinkedField",
            "name": "recentItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSearchableEntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": (v8/*: any*/),
                        "type": "JiraIssue"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v9/*: any*/),
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issueSearch",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v8/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRecentJiraProjectAndIssueQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraSearchableEntityConnection",
            "kind": "LinkedField",
            "name": "recentItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSearchableEntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v11/*: any*/),
                          (v12/*: any*/)
                        ],
                        "type": "JiraIssue"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v10/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v9/*: any*/),
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issueSearch",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v10/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "876dd1ed51260d9cbf47835d7194768e",
    "id": "eb3dba15d458b202626bfcea5d65befda4883877fde34e5f6d37d9d15e794364",
    "metadata": {},
    "name": "useRecentJiraProjectAndIssueQuery",
    "operationKind": "query",
    "text": "query useRecentJiraProjectAndIssueQuery($cloudId:ID!,$jql:String!){jira{recentItems(cloudId:$cloudId,types:[ISSUE],filter:{includeArchivedProjects:false},first:1){edges{node{__typename,...on JiraIssue{key,summary,webUrl,issueType{name,id},projectField{project{key,name,webUrl,id},id}},...on Node{__isNode:__typename,id}}}},issueSearch(cloudId:$cloudId,issueSearchInput:{jql:$jql},first:1)@optIn(to:\"JiraSpreadsheetComponent-M1\"){edges{node{key,summary,webUrl,issueType{name,id},projectField{project{key,name,webUrl,id},id},id}}}}}"
  }
};
})();

(node as any).hash = "a33e1370319203ffc089816d9591fc30";

export default node;
